<template>
    <div :class="$style['product-page']">
        <div class="content-width">
            <h1 :class="$style['product-title']">{{ product.name }}</h1>
            <div :class="$style['product-content']">
                <div :class="$style['media-gallery-container']">
                    <media-gallery
                        :value="media"
                        :full-width="!verticalMediaGallery"
                        :vertical="verticalMediaGallery"
                    >
                        <!-- <template #under-image>
                        <div
                            :class="$style['desktop-wrapper-spoerg-eksp']"
                            v-if="product.isStockProduct === true"
                        >
                            <spoerg-eksperterne></spoerg-eksperterne>
                        </div>
                    </template> -->
                        <template #inside-frame v-if="product.bidIsPaid">
                            <sold-overlay
                                :class="$style['sold-overlay']"
                            ></sold-overlay>
                        </template>
                        <template #after-first-image>
                            <product-image-overlays
                                :product="product"
                            ></product-image-overlays>
                        </template>
                    </media-gallery>
                    <StayInclusionInfoBox
                        :product="product"
                        v-if="
                            productHasStayInformation &&
                            currentBreakpoint?.up('lg') == true
                        "
                        :class="$style['stay-inclusion-lg']"
                    />
                    <div :class="[$style['description-lg']]">
                        <div
                            v-html="product.description"
                            :class="[$style['product-description']]"
                        ></div>
                        <video-viewer
                            :class="[$style['video-viewer']]"
                            v-if="product.videoLink != null"
                            :video-link="product.videoLink"
                        ></video-viewer>
                    </div>
                </div>
                <div :class="$style['specs-container']">
                    <specs
                        :product="product"
                        :setup="setup"
                        :phone-validation="phoneValidation"
                        :overwrite-settings="overwriteSettings"
                    ></specs>
                    <div
                        :class="$style['delivery-and-info']"
                        v-if="
                            (product.hasServiceFee &&
                                product.serviceFeePercent != null) ||
                            (!product.hideFreightMethods &&
                                cheapestMethod != null) ||
                            pickupItem != null ||
                            product.canBeParked
                        "
                    >
                        <div
                            v-if="
                                product.hasServiceFee &&
                                product.serviceFeePercent != null
                            "
                        >
                            {{
                                format(
                                    labels.frontendProductpage.serviceFeeInfo,
                                    product.serviceFeePercent
                                )
                            }}
                            <span
                                :class="[
                                    'tooltip-hint popup-text gray small',
                                    $style['tooltip-service-fee'],
                                ]"
                            >
                                <span class="normal-size">
                                    {{
                                        labels.frontendProductpage
                                            .serviceFeeAbout
                                    }}
                                </span>
                            </span>
                        </div>
                        <div
                            v-if="product.canBeParked"
                            :class="$style['can-be-parked-text']"
                        >
                            {{
                                labels.frontendProductpage[
                                    product.canBeParked_sponsor
                                        ? "canBeParked_sponsor"
                                        : "canBeParked"
                                ]
                            }}
                            <span
                                :class="[
                                    'tooltip-hint popup-text gray small',
                                    $style['tooltip-can-be-parked'],
                                ]"
                            >
                                <span class="normal-size">
                                    {{
                                        labels.frontendProductpage[
                                            product.canBeParked_sponsor
                                                ? "canBeParkedAbout_sponsor"
                                                : "canBeParkedAbout"
                                        ]
                                    }}
                                </span>
                            </span>
                        </div>
                        <div
                            v-if="
                                (!product.hideFreightMethods &&
                                    cheapestMethod != null) ||
                                pickupItem != null
                            "
                        >
                            <div :class="$style['delivery-header']">
                                <strong
                                    ><template
                                        v-if="
                                            pickupItem != null &&
                                            cheapestMethod != null
                                        "
                                        >{{
                                            labels.frontendProductpage
                                                .deliveryInfoHeader_deliveryAndPickup
                                        }}</template
                                    ><template
                                        v-else-if="
                                            pickupItem != null &&
                                            cheapestMethod == null
                                        "
                                        >{{
                                            labels.frontendProductpage
                                                .deliveryInfoHeader_pickup
                                        }}</template
                                    ><template
                                        v-else-if="
                                            pickupItem == null &&
                                            cheapestMethod != null
                                        "
                                        >{{
                                            labels.frontendProductpage
                                                .deliveryInfoHeader_delivery
                                        }}</template
                                    ><template v-else>{{
                                        labels.frontendProductpage
                                            .deliveryInfoHeader
                                    }}</template></strong
                                >
                            </div>
                            <div
                                v-if="
                                    !product.hideFreightMethods &&
                                    cheapestMethod != null
                                "
                            >
                                {{ cheapestMethod.text }}
                                {{ cheapestMethod.price.toLowerCase() }}
                            </div>
                            <div v-if="pickupItem != null">
                                {{ pickupItem }}
                            </div>
                        </div>
                    </div>
                    <div
                        :class="$style['cause-info']"
                        v-if="product.cause != null"
                    >
                        {{ labels.frontendProductpage.forCause }}
                        <strong>{{ product.cause.name }}</strong>
                        <template
                            v-if="
                                product.cause.showMoreLabel != null &&
                                product.cause.showMoreLink != null
                            "
                            ><br />
                            <a
                                :href="product.cause.showMoreLink"
                                :class="$style['show-more-link']"
                                >{{ product.cause.showMoreLabel }}</a
                            >
                        </template>
                    </div>
                    <div
                        :class="$style['sponsor-info']"
                        v-if="product.sponsor != null"
                    >
                        {{ labels.frontendProductpage.donatedBy }}
                        <strong>{{ product.sponsor.name }}</strong>
                        <template
                            v-if="
                                product.sponsor.showMoreLabel != null &&
                                product.sponsor.showMoreLink != null
                            "
                            ><br />
                            <a
                                :href="product.sponsor.showMoreLink"
                                :class="$style['show-more-link']"
                                >{{ product.sponsor.showMoreLabel }}</a
                            >
                        </template>
                    </div>
                    <StayInclusionInfoBox
                        :product="product"
                        v-if="
                            productHasStayInformation &&
                            !(currentBreakpoint?.up('lg') == true)
                        "
                        :class="$style['stay-inclusion-lg']"
                    />
                    <RedeemInfoBox
                        v-if="
                            !product.isStockProduct || product.forceRedeemInfo
                        "
                        :class="$style['redeem-info-box']"
                        :product="product"
                    >
                        <template
                            #after-items
                            v-if="product.thirdPartyWarning != null"
                        >
                            <li v-html="product.thirdPartyWarning"></li>
                        </template>
                    </RedeemInfoBox>
                </div>
            </div>
        </div>
        <!-- <div
            :class="[$style['mobile-wrapper-spoerg-eksp'], 'content-width']"
            v-if="product.isStockProduct === true"
        >
            <spoerg-eksperterne></spoerg-eksperterne>
        </div> -->
        <!-- <div
            v-if="productHasStayInformation"
            :class="['content-width', $style['product-info-boxes']]"
        >
            <RedeemInfoBox :product="product" />
        </div> -->

        <div :class="['content-width', $style['description-sm']]">
            <div
                v-html="product.description"
                :class="[$style['product-description']]"
            ></div>
            <video-viewer
                :class="[$style['video-viewer']]"
                v-if="product.videoLink != null"
                :video-link="product.videoLink"
            ></video-viewer>
        </div>
        <usp v-if="product.isStockProduct === true" auction></usp>
        <div
            v-if="product.brandInfo != null"
            :class="['content-width', $style['brand-info-comp']]"
        >
            <brand-info :brand-info="product.brandInfo"></brand-info>
        </div>
        <div :class="['content-width', $style['related-info']]">
            <related-products :product="product"></related-products>
        </div>
    </div>
</template>

<style module lang="scss">
@import "../../../../responsive/style.scss";
@import "box.scss";

.video-viewer {
    margin-top: 1em;
}

.product-title {
    font-size: 16px;
    text-align: left;
    color: #3f3f3f;
    margin-top: 12px;
    margin-bottom: 12px;
    line-height: 1em;
}

.brand-info-comp {
    padding-bottom: 0;
}

.related-info {
    padding-bottom: 0;
}

.product-content {
    display: flex;
    align-items: start;
    justify-content: stretch;
    flex-direction: column;
}

.specs-container {
    margin-top: 15px;
    width: 100%;
}

.sponsor-info {
    @extend %box;
    margin-top: 15px;
    font-size: 13px;
    .show-more-link {
        color: #02b6b5;
        text-decoration: underline;
    }
}

.cause-info {
    @extend %box;
    margin-top: 15px;
    font-size: 13px;
    .show-more-link {
        color: #02b6b5;
        text-decoration: underline;
    }
}

.redeem-info-box {
    margin-top: 15px;
}

.delivery-and-info {
    @extend %box;
    font-size: 12px;
    margin-top: 15px;
    > div + div {
        margin-top: 0.5em;
    }
    .tooltip-service-fee {
        vertical-align: -0.39em;
        margin-left: 3px;
    }

    .tooltip-can-be-parked {
        vertical-align: -0.39em;
        margin-left: 3px;
    }

    .delivery-header {
        font-size: 14px;
    }
}

.sold-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.product-description {
    color: #666666;
    font-family: "Open Sans";
    font-size: 13px;
    margin-top: 15px;
    a {
        text-decoration: underline !important;
    }
}

.stay-inclusion-lg {
    margin-top: 15px;
}

.description-lg {
    display: none;
}
@include media-breakpoint-up(lg) {
    .description-lg {
        display: revert;
    }
    .description-sm {
        display: none;
    }
}

.desktop-wrapper-spoerg-eksp {
    display: none;
    max-width: 400px;
}

.mobile-wrapper-spoerg-eksp {
    margin-top: 40px;
    display: block;
}

.product-info-boxes {
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-size: 13px;
}

@include media-breakpoint-up(lg) {
    .desktop-wrapper-spoerg-eksp {
        display: block;
    }

    .mobile-wrapper-spoerg-eksp {
        display: none;
    }

    .product-title {
        font-size: 30px;
        margin-top: 15px;
        margin-bottom: 20px;
        line-height: 1em;
        text-align: left;
    }

    .product-content {
        flex-direction: row;
    }

    .media-gallery-container {
        flex: 0;
        display: flex;
        flex-direction: column;
    }

    .specs-container {
        margin-left: 50px;
        margin-top: 0;
        flex: 1;
    }

    .product-info-boxes {
        flex-direction: row;
        align-items: stretch;
        justify-content: stretch;
    }
}
</style>

<script setup lang="ts">
import mediaGallery from "../media-gallery/MediaGalleryMain.vue";
import specs from "./specs.vue";
import usp from "../../../content/usp/usp.vue";
import VideoViewer from "../common/video-link/video-viewer.vue";
import brandInfo from "../shop/brand-info.vue";
// import relatedProducts from "./related-products.vue";
// import SpoergEksperterne from "./spoerg-eksperterne.vue";
import { computed, ref, type PropType } from "vue";
import { type Setup, type AuctionProduct, type PhoneValidation } from "./types";
import labels from "../../shared/labels";
import { registerVueProductSpec } from "../../../../utilities/spec-updater/registerVueProductSpec";
import { registerVueProductCountdown } from "../../../../utilities/countdown";
import { format } from "../../../../shared/utils/string";
import { getCheapestFreightMethod } from "../product-specs/delivery-info";
import { createCurrencyFormatter } from "../common/amount-format";
import RelatedProducts from "./related-products.vue";
import SoldOverlay from "./sold-overlay.vue";
import StayInclusionInfoBox from "./StayInclusionInfoBox.vue";
import RedeemInfoBox from "./RedeemInfoBox.vue";
import ProductImageOverlays from "../common/product-image-overlays.vue";
import { getBreakpointObservable } from "../../../../shared/breakpoint-observable";
import { type OverwriteSettings } from "../../../commons/product/overwrite-settings";
const formatter = createCurrencyFormatter();
function formatAmount(value: number) {
    return formatter.format(value);
}

const props = defineProps({
    product: {
        type: Object as PropType<AuctionProduct>,
        required: true,
    },
    setup: {
        type: Object as PropType<Setup>,
        required: true,
    },
    overwriteSettings: Object as PropType<OverwriteSettings>,
    phoneValidation: Object as PropType<PhoneValidation>,
});

const breakpointObserver = getBreakpointObservable();

const currentBreakpoint = computed(() => {
    return breakpointObserver.currentBreakpoint;
});
const verticalMediaGallery = computed(() => {
    return currentBreakpoint.value?.up("lg") ?? false;
});
const productHasStayInformation = computed(() => {
    return (
        props.product.experienceInformation != null &&
        props.product.experienceInformation.stayInclusions.length > 0
    );
});

const initializedDate = ref<Date>();
const initialSeconds = ref<number>();

const cheapestMethod = computed(() => {
    let label = labels.frontendProductpage.specs.deliveryLabel;
    if (typeof label !== "string") return undefined;
    if (label.endsWith(":")) {
        label = label.substring(0, label.length - 1);
    }

    const cheapest = getCheapestFreightMethod(
        props.product.methods.filter((x) => x.isPickupMethod == false)
    );
    if (cheapest == null) {
        const deliveryItem = props.product.methods.find(
            (x) => x.deliveryChoice == "Delivery"
        );
        if (deliveryItem != null) {
            return {
                text: label,
                price: formatAmount(deliveryItem.price),
            };
        }
        return undefined;
    }

    const item = {
        text: label,
        price:
            props.product.methods.filter(
                (m) => m.deliveryChoice === "FreightMethod"
            ).length == 1
                ? formatAmount(cheapest.price)
                : (
                      labels.frontendProductpage.specs
                          .deliveryStartingPrice as string
                  ).replace(/\{0\}/g, formatAmount(cheapest.price)),
    };

    return item;
});

const pickupItem = computed(() => {
    const pickupMethod = props.product.methods.find(
        (x) => x.isPickupMethod || x.deliveryChoice == "Pickup"
    );
    if (
        pickupMethod == null ||
        pickupMethod.specLabel == null ||
        pickupMethod.specHint == null
    )
        return undefined;
    return pickupMethod.specLabel + " " + pickupMethod.specHint;
});

import fallbackImage from "../fallback-image.jpg?file";
import { type MediaItem } from "../media-gallery/types";
const media = computed(() => {
    if (props.product.media != null && props.product.media.length > 0)
        return props.product.media;
    const res: MediaItem[] = [
        {
            src: fallbackImage,
            alt: "Billede mangler",
            type: "picture",
            size: {
                width: 470,
                height: 353,
            },
            sources: [],
            srcset: "",
            thumbnail: fallbackImage,
        },
    ];
    return res;
});

registerVueProductSpec({
    productId: props.product.id,
    secondsLeftGetter: () => props.product.timeTotalSeconds,
    callbackUpdatedItem(item) {
        initializedDate.value = undefined;
        initialSeconds.value = undefined;

        props.product.timeIsNotStarted = item.timeIsNotStarted;
        props.product.timeTotalSeconds = item.timeTotalSeconds;
        if (item.isAuction) {
            props.product.currentBid = item.price;
            props.product.estimatedPrice = item.value;
            props.product.showEstimatedPrice =
                item.value != null && item.value > 0;
            props.product.winningBid =
                item.currentBidOwner != null
                    ? {
                          name: item.currentBidOwner,
                          currentUser: item.currentBidIsCurrentUser === true,
                          maxBid: item.currentUserMaxBid,
                      }
                    : undefined;
            props.product.hasBidOnProduct =
                item.currentUserHasBidOnProduct === true;
            props.product.bidders = item.bidders ?? 0;
        }
    },
});

registerVueProductCountdown({
    itemId: props.product.id,
    secondsGetter: () => props.product.timeTotalSeconds,
    secondsSetter: (v) => {
        props.product.timeTotalSeconds = v;
    },
    getInitializedDate: () => initializedDate.value,
    getInitialSeconds: () => initialSeconds.value,
    setInitializedDate: (v) => (initializedDate.value = v),
    setInitialSeconds: (v) => (initialSeconds.value = v),
});
</script>
